import { render, staticRenderFns } from "./VolunteerMatchStandardConfirm.vue?vue&type=template&id=19ae3e6b"
import script from "./VolunteerMatchStandardConfirm.vue?vue&type=script&lang=ts"
export * from "./VolunteerMatchStandardConfirm.vue?vue&type=script&lang=ts"
import style0 from "./VolunteerMatchStandardConfirm.vue?vue&type=style&index=0&id=19ae3e6b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports